import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import { Icon, Button } from '@haldor/ui';
import './Styles.scss';

var WopiFrame = /*#__PURE__*/function (_Component) {
  _inherits(WopiFrame, _Component);

  var _super = _createSuper(WopiFrame);

  function WopiFrame(props) {
    var _this;

    _classCallCheck(this, WopiFrame);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setContainer", function (element) {
      return _this.container = element;
    });

    _defineProperty(_assertThisInitialized(_this), "_setTrigger", function (element) {
      return _this.trigger = element;
    });

    _defineProperty(_assertThisInitialized(_this), "_setIframe", function (element) {
      return _this.iframe = element;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('resize', _this.calculateIframeHeight);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.calculateIframeHeight();

      window.addEventListener('resize', _this.calculateIframeHeight);
    });

    _defineProperty(_assertThisInitialized(_this), "calculateIframeHeight", function () {
      if (_this.state.fullscreen) {
        if (_this.iframe != null) {
          var triggerHeight = _this.trigger.scrollHeight;
          _this.iframe.style.height = "calc(".concat(window.innerHeight, "px - ").concat(triggerHeight, "px)");
        }

        return false;
      }

      if (_this.iframe != null) {
        var height = 0;
        var body = document.querySelector('body');
        var footer = body.querySelector('.site-footer');
        var header = body.querySelector('.teams-header');
        var desktopHeader = body.querySelector('.desktop-header-spacing');
        height = window.innerHeight;

        if (footer != null) {
          height = height - footer.scrollHeight;
        }

        if (header != null) {
          height = height - header.scrollHeight;
        }

        if (desktopHeader != null) {
          height = height - desktopHeader.scrollHeight;
        }

        _this.iframe.style.height = height + 'px';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFullscreenTrigger", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                _context.next = 3;
                return _this.setState({
                  fullscreen: !_this.state.fullscreen
                });

              case 3:
                _this.toggleFullscreen();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleFullscreen", function () {
      var body = document.body;

      if (_this.state.fullscreen) {
        _this.container.style.position = 'fixed';
        _this.container.style.top = '0';
        _this.container.style.left = '0';
        _this.container.style.height = '100%';
        _this.container.style.width = '100%';
        _this.container.style.zIndex = '9999999999999999999';
        _this.container.style.background = 'white';

        if (_this.iframe != null) {
          var triggerHeight = _this.trigger.scrollHeight;
          _this.iframe.style.height = "calc(".concat(window.innerHeight, "px - ").concat(triggerHeight, "px)");
        }

        var menu = body.querySelector('.c--sider');

        if (menu != null) {
          menu.style.display = 'none';
        }

        var header = body.querySelector('.desktop-header');

        if (header != null) {
          header.style.display = 'none';
        }

        body.style.overflow = 'hidden';
      } else {
        var _menu = body.querySelector('.c--sider');

        if (_menu != null) {
          _menu.style.display = 'block';
        }

        var _header = body.querySelector('.desktop-header');

        if (_header != null) {
          _header.style.display = 'flex';
        }

        _this.container.style = {};

        _this.calculateIframeHeight();

        body.style.overflow = 'initial';
      }
    });

    _this.state = {
      fullscreen: false
    };
    _this.container = null;
    _this.trigger = null;
    _this.iframe = null;
    return _this;
  }

  _createClass(WopiFrame, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectedFiles = this.props.folderFiles.filter(function (ss) {
        return ss.webUrlEditMode == _this2.props.activeFile || ss.webUrlViewMode === _this2.props.activeFile;
      });

      if (selectedFiles && selectedFiles.length > 0) {
        var webURL = selectedFiles[0].webUrl;
      }

      var iframe = "\n\t\t\t<iframe\n\t\t\t\tsrc=\"".concat(this.props.activeFile, "\"\n\t\t\t\ttitle=\"File\"\n\t\t\t\tclass=\"iframe-element\"\n\t\t\t\tallow=\"camera;microphone\"\n\t\t\t\tstyle=\"width: 100%;height:100%;\"\n\t\t\t/>\n\t\t");
      return /*#__PURE__*/React.createElement("div", {
        className: "wopi-frame"
      }, /*#__PURE__*/React.createElement("div", {
        className: "iframe-container",
        ref: this._setContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: "fullscreen-trigger",
        ref: this._setTrigger
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          cursor: 'pointer'
        },
        onClick: this.onFullscreenTrigger
      }, this.state.fullscreen ? /*#__PURE__*/React.createElement(Icon, {
        name: "Collapse"
      }) : /*#__PURE__*/React.createElement(Icon, {
        name: "Expand"
      }), this.props.translate('fullscreen'))), this.props.activeFile && this.props.activeFile.length > 2001 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "warning-box"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          alignSelf: 'flex-start'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Info_Blue"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("p", null, this.props.translate("We’re sorry but we can’t display the file in Haldor at the moment. But you can open it by clicking “Open file in workspace”.")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, this.props.translate("When you’re ready to submit the file, just click “Submit” as usual.")))), /*#__PURE__*/React.createElement("div", {
        className: "center-container",
        style: {
          marginTop: 20,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        style: {
          display: 'inline'
        },
        href: webURL
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "External"
      }), this.props.translate("open-file-in-workspace"))))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }), /*#__PURE__*/React.createElement("div", {
        ref: this._setIframe,
        dangerouslySetInnerHTML: {
          __html: iframe
        }
      }))));
    }
  }]);

  return WopiFrame;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    folderFiles: state.assignments.folderFiles
  };
}

export default connect(mapStateToProps)(WopiFrame);